import Service, { inject as service } from '@ember/service';

export default class CompanyContactCommands extends Service {
  @service api;

  /**
   *
   * @param companyContactId
   * @returns {Promise}
   */
  destroyCompanyContact(companyContactId) {
    return this.api.delete(`company-contact/${companyContactId}`);
  }

  /**
   *
   * @param companyId
   * @param {Array<String>=} includes
   * @returns {Promise}
   */
  loadCompanyContacts(companyId, withTrashed = false, includes = null) {
    const options = {};

    if (includes) {
      options.params = {
        include: includes.join(','),
      }
    }

    return this.api.request(`companies/${companyId}/billing-contacts`, options);
  }

  /**
   *
   * @param companyId
   * @param firstName
   * @param lastName
   * @param email
   * @returns {Promise}
   */
  storeCompanyContact({
    companyId,
    firstName,
    lastName,
    email,
  } = {}) {
    return this.api.post(`companies/${companyId}/add-billing-contact`, {
      jsonData: {
        first_name: firstName,
        last_name: lastName,
        email,
      }
    })
  }

  /**
   *
   * @param companyContact
   * @returns {Promise}
   */
  updateCompanyContact({
    companyContactId,
    email,
  } = {}) {
    return this.api.put(`company-contact/${companyContactId}`, {
      jsonData: {
        email,
      }
    })
  }
}
